import token, { tokenToVars } from '../token';
import Steps from './steps';

export { Steps };
export default tokenToVars(Steps, token);
